import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20rocket%20launch%20and%20ascending%20stars%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=newbizhero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: '新規事業開発',
  heroImage: HERO_IMG,
  tag: 'New Business Development',
  title: <>生成AIが加速する<br />新規事業の立ち上げ</>,
  subtitle: 'アイデア創出から市場参入・成長加速まで、新規事業の全フェーズを支援。生成AIの力で、従来の数倍のスピードで事業を検証・立ち上げます。',
  icon: 'ri-lightbulb-flash-line',
  services: [
    { icon: 'ri-search-2-line', title: 'ビジネス機会の発掘', desc: '生成AIを活用した市場調査と機会分析で、見落とされていた事業ポテンシャルを発見します。' },
    { icon: 'ri-draft-line', title: 'ビジネスモデル設計', desc: '持続可能でスケーラブルなビジネスモデルを、素早く設計・検証します。' },
    { icon: 'ri-global-line', title: '市場参入戦略', desc: 'リスクを最小化しながら、最適なタイミングと方法で市場に参入する戦略を策定します。' },
    { icon: 'ri-code-box-line', title: 'プロダクト開発', desc: 'ユーザーニーズに応えるプロダクトを、生成AIを活用して高速に設計・開発します。' },
    { icon: 'ri-rocket-2-line', title: 'GTM（市場投入）計画', desc: '包括的なローンチと成長戦略を策定し、スタートダッシュを確実に成功させます。' },
    { icon: 'ri-shake-hands-line', title: 'パートナーシップ開発', desc: '事業成長を加速させる戦略的パートナーの発掘と関係構築をサポートします。' },
  ],
  steps: [
    { title: '機会発見・検証', desc: '生成AIを活用した市場リサーチで、事業機会を素早く発掘・評価します。' },
    { title: 'ビジネスモデル設計', desc: '収益性と持続可能性を兼ね備えたビジネスモデルを構築します。' },
    { title: 'MVP開発・市場テスト', desc: '最小限の投資で市場の反応を検証し、方向性を早期に確定します。' },
    { title: '本格ローンチ・スケール', desc: '検証された戦略で本格展開し、成長を加速させます。' },
  ],
  benefits: [
    '生成AIによるリサーチ・検証で、新規事業の立ち上げ期間を大幅に短縮',
    '徹底的な市場検証でリスクを低減し、成功確率を高める',
    '経験豊富なビジネスビルダーの知見と最新AI技術の融合',
    '参入初日からの持続的な競争優位性の構築',
    '業種・規模を問わず、最適な事業開発フレームワークを適用',
    '初期投資を抑えながら、スピーディーに市場の可能性を探索',
  ],
};

export default function NewBusinessPage() {
  useSEO({
    title: '東京 新規事業開発 TradFit株式会社 | 生成AIで加速する事業立ち上げ',
    description: 'TradFit株式会社の新規事業開発サービス。アイデア創出から市場参入・成長加速まで、生成AIの力で事業を高速に検証・立ち上げます。',
    keywords: '新規事業開発, 生成AI, ビジネスモデル, 市場参入, 東京',
    path: '/new-business',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('新規事業開発 | TradFit株式会社', 'TradFit株式会社の新規事業開発サービス。', '/new-business'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: '新規事業開発', path: '/new-business' }]),
        generateServiceSchema('新規事業開発', 'アイデア創出から市場参入・成長加速までの新規事業開発支援サービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
